import React from "react";
import Navbar from "../../../../posnavbar/Navbar";
import { Box } from "@mui/material";
import { useNavigate } from "react-router-dom";
import "./index.css";
import InputAdornment from "@mui/material/InputAdornment";
import Visibility from "@mui/icons-material/Visibility";
import VisibilityOff from "@mui/icons-material/VisibilityOff";
import IconButton from "@mui/material/IconButton";
import Input from "@mui/material/Input";
import { useDispatch } from "react-redux";
import { addmanagerpin, addmanageruidx } from "../../../all-products/redux/Actions/SessionActions";
import { getmangerPin, getmangeruidx } from "../../../all-products/redux/Reducers/sessionReducer";
import { useSelector } from "react-redux";
import { getManagers, validateManagerPin } from "../../../../../../config/Services";
import { useState, useEffect } from "react";
import SoftSelect from "components/SoftSelect";
import StyledButton from "../../../all-products/components/custom/StyledButton";
import CreditCardOffIcon from "@mui/icons-material/CreditCardOff";
import PaymentsIcon from "@mui/icons-material/Payments";
import { useContext } from "react";
import { UserContext } from "../../../../../../App";
import useGetDevice from "../../../hooks/useGetDevice";
import { useSnackbar } from "../../../hooks/SnackbarProvider";
import StyledSelect from "../../../all-products/components/custom/StyledSelect";
import { customEventTrigger } from "../../../../../../analytics";
import OnlinePayment from "../../../../../../assets/images/icons/flags/online-payment.png";
import OfflinePayment from "../../../../../../assets/images/icons/flags/offline-payment.png";
import { SignalIcon } from "@heroicons/react/24/outline";
import { SignalSlashIcon } from "@heroicons/react/24/outline";
import PosCustomIcon from "../../../../../../customComponents/PosCustomIcon/PosCustomIcon";

const PaymentTerminal = () => {
  const navigate = useNavigate();
  const showSnackbar = useSnackbar();
  const isMobile = useGetDevice();
  const { color } = useContext(UserContext);
  const [managerModal, setmanagerModal] = useState(false);
  const managerNumber = useSelector(getmangeruidx);
  const mangerPin = useSelector(getmangerPin);
  const contextId = localStorage.getItem("locId");
  const [isVisible, setVisible] = useState(false);
  const [loader, setLoader] = useState(false);
  const [pinValue, setPinValue] = useState("");
  const machineId = localStorage.getItem("machineId");
  const storeMode = localStorage.getItem("storeMode");

  const [currStoreMode, setCurrStoreMode] = useState(-1);

  const toggle = () => {
    setVisible(!isVisible);
  };
  const dispatch = useDispatch();

  const handleOffline = () => {
    if (storeMode === "OFFLINE") return;

    setmanagerModal(true);
  };

  const [managerDetails, setManagerDetails] = useState([{}]);

  useEffect(() => {
    const payload = { contextId };
    getManagers(payload).then((res) => {
      const response = res?.data?.data?.map((e) => {
        return {
          value: e?.mobile_number,
          label: e?.first_name,
        };
      });
      setManagerDetails(response);
    });
  }, []);

  const handleProceedOffline = (e) => {
    e.preventDefault();
    setLoader(true);
    let managerpayload = {
      mobile: managerNumber,
      primaryPassword: mangerPin,
    };
    validateManagerPin(managerpayload)
      .then((res) => {
        showSnackbar("Successfully switched to offline payment mode", "success");
        setLoader(false);
        dispatch(addmanagerpin(""));
        dispatch(addmanageruidx(""));
        setPinValue("");
        localStorage.setItem("storeMode", "OFFLINE");
        localStorage.setItem("cartStoreMode", "OFFLINE");
        setmanagerModal(false);
      })
      .catch((err) => {
        showSnackbar(err?.response?.data?.message || err?.message, "error");
        setLoader(false);
        setPinValue("");
        setmanagerModal(false);
      });
  };

  const handleClose = () => {
    setmanagerModal(false);
    setPinValue("");
    dispatch(addmanagerpin(""));
  };

  const handleOnline = () => {
    if (storeMode === "ONLINE") return;

    setmanagerModal(true);
  };

  const handlepaymentOnline = (e) => {
    e.preventDefault();
    customEventTrigger("pos_select_payment", { payment_value: e });
    setLoader(true);
    if (machineId) {
      let managerpayload = {
        mobile: managerNumber,
        primaryPassword: mangerPin,
      };
      validateManagerPin(managerpayload)
        .then((res) => {
          showSnackbar("Success payment mode is online", "success");
          setLoader(false);
          dispatch(addmanagerpin(""));
          dispatch(addmanageruidx(""));
          setPinValue("");
          localStorage.setItem("storeMode", "ONLINE");
          localStorage.setItem("cartStoreMode", "ONLINE");
          setmanagerModal(false);
        })
        .catch((err) => {
          showSnackbar(err?.response?.data?.message || err?.message, "error");
          setLoader(false);
          setPinValue("");
          setmanagerModal(false);
        });
    } else {
      showSnackbar("You are not connected to a payment machine.", "error");
      setLoader(false);
    }
  };

  useEffect(() => {
    const handleKeyPress = (event) => {
      if (event.key === "ArrowLeft" && currStoreMode >= 0) {
        setCurrStoreMode((prev) => prev - 1);
      } else if (event.key === "ArrowRight" && currStoreMode <= 1) {
        setCurrStoreMode((prev) => prev + 1);
      } else if (event.key === "Enter" && currStoreMode == 0 && storeMode === "OFFLINE") {
        handleOnline();
      } else if (event.key === "Enter" && currStoreMode == 1 && storeMode === "ONLINE") {
        handleOffline();
      } else if (event.key === "Escape" && managerModal) {
        handleClose();
      }
    };

    document.addEventListener("keydown", handleKeyPress);

    return () => {
      document.removeEventListener("keydown", handleKeyPress);
    };
  }, [storeMode, managerModal]);

  return (
    <Navbar>
      <Box className="container">
        {/* {storeMode === "OFFLINE" ? (
            <div className="terminal-wrapper" onClick={handleOnline}>
              <h2>Payment Method</h2>
              <b>Change payment mode and start billing online</b>
              <br />
              <div className="icons-wrapper-flex">
                <CreditCardOffIcon className="credit-off-icons" />
                <b>You are offline</b>
              </div>
            </div>
          ) : (
            <div className="terminal-wrapper" onClick={handleOffline}>
              <h2>Payment Method</h2>
              <b>Change payment mode and start billing offline</b>
              <br />
              <div className="icons-wrapper-flex">
                <PaymentsIcon className="active-icons-ons" />
                <b>You are online</b>
              </div>
            </div>
          )} */}

        <div className="pt-sticky-header">
          <div className="pt-header-content">
            <div className="pt-header-left">
              <button type="button" className="theme-back-button" onClick={() => navigate(-1)}>
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="24"
                  height="24"
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  aria-hidden="true"
                >
                  <path d="m12 19-7-7 7-7"></path>
                  <path d="M19 12H5"></path>
                </svg>
              </button>
              <h1 className="pt-header-title">Payment Terminal</h1>
            </div>
          </div>
        </div>

        <div className="payment-modes-card-grid">
          <div
            className={`payment-mode-card-par ${
              storeMode === "ONLINE" && "payment-mode-card-par-active"
            }`}
            onClick={handleOnline}
          >
            <div className="payment-mode-card-header" style={{ color: "#0B742C" }}>
              <PosCustomIcon
                icon={<SignalIcon />}
                height={"1.25rem"}
                width={"1.25rem"}
                color='"#0B742C"'
              />
              <div>Online</div>
            </div>
            <div className="payment-mode-card-img-par">
              <img src={OnlinePayment} alt="online payment" className="payment-card-img-div" />
            </div>
            <div style={{ textAlign: "left" }}>
              {storeMode === "ONLINE" ? (
                <>
                  <p className="payment-mode-active-clr">Current payment mode is online</p>
                  <p className="payment-mode-subtext">You are currently online. </p>
                </>
              ) : (
                <>
                  <p>Online mode</p>
                  <p className="payment-mode-subtext">
                    Change billing method to start billing online
                  </p>
                </>
              )}
            </div>
          </div>
          <div
            className={`payment-mode-card-par ${
              storeMode === "OFFLINE" && "payment-mode-card-par-active"
            }`}
            onClick={handleOffline}
          >
            <div className="payment-mode-card-header" style={{ color: "#E90000" }}>
              <PosCustomIcon
                icon={<SignalSlashIcon />}
                height={"1.25rem"}
                width={"1.25rem"}
                color="#E90000"
              />
              <div>Offline</div>
            </div>
            <div className="payment-mode-card-img-par">
              <img src={OfflinePayment} alt="offline payment" className="payment-card-img-div" />
            </div>
            <div style={{ textAlign: "left" }}>
              {storeMode === "OFFLINE" ? (
                <>
                  <p className="payment-mode-active-clr-offline">Current payment mode is offline</p>
                  <p className="payment-mode-subtext">You are currently offline.</p>
                </>
              ) : (
                <>
                  <p>Offline mode</p>
                  <p className="payment-mode-subtext">
                    Change billing method to start billing offline
                  </p>
                </>
              )}
            </div>
          </div>
        </div>
      </Box>
      {managerModal && (
        <div className="menu_payment_config_manager_modal-overlay">
          <div className="menu_payment_config_manager_modal-card">
            <button
              className="menu_payment_config_manager_modal-close-btn"
              onClick={handleClose}
              type="button"
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="16"
                height="16"
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
              >
                <path d="M18 6 6 18" />
                <path d="m6 6 12 12" />
              </svg>
            </button>

            <div className="menu_payment_config_manager_modal-header">
              <div className="menu_payment_config_manager_modal-lock-icon">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="28"
                  height="28"
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="#60a5fa"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                >
                  <circle cx="12" cy="16" r="1" />
                  <rect x="3" y="10" width="18" height="12" rx="2" />
                  <path d="M7 10V7a5 5 0 0 1 10 0v3" />
                </svg>
              </div>
              <h3 className="menu_payment_config_manager_modal-title">
                {storeMode === "OFFLINE" ? "Switch to Online Mode" : "Switch to Offline Mode"}
              </h3>
              <p className="menu_payment_config_manager_modal-subtitle">
                {storeMode === "OFFLINE"
                  ? "Online mode manager access"
                  : "Offline mode manager access"}
              </p>
            </div>

            <div className="menu_payment_config_manager_modal-body">
              <form onSubmit={storeMode === "OFFLINE" ? handlepaymentOnline : handleProceedOffline}>
                <div className="menu_payment_config_manager_modal-field-group">
                  <label className="menu_payment_config_manager_modal-label">Select Manager</label>
                  <StyledSelect
                    onChange={(e) => dispatch(addmanageruidx(e.value))}
                    options={managerDetails}
                    placeholder={!isMobile ? "Use arrow key to select manager" : "Select"}
                    maxMenuHeight={180}
                  />
                </div>

                <div className="menu_payment_config_manager_modal-field-group">
                  <label className="menu_payment_config_manager_modal-label">Enter PIN</label>
                  <div className="menu_payment_config_manager_modal-pin-wrapper">
                    <Input
                      id="outlined-adornment-password"
                      type={isVisible ? "number" : "password"}
                      inputProps={{ inputMode: "numeric", maxLength: 4 }}
                      autoComplete="new-password"
                      value={pinValue}
                      onChange={(e) => {
                        const val = e.target.value.replace(/\D/g, "").slice(0, 4);
                        setPinValue(val);
                        dispatch(addmanagerpin(val));
                      }}
                      className="numberInput1"
                      placeholder="••••"
                      disableUnderline
                      endAdornment={
                        <InputAdornment position="end">
                          <IconButton
                            aria-label="toggle password visibility"
                            onClick={toggle}
                            edge="end"
                          >
                            {isVisible ? <VisibilityOff /> : <Visibility />}
                          </IconButton>
                        </InputAdornment>
                      }
                    />
                  </div>
                </div>

                <StyledButton
                  loading={loader}
                  disabled={mangerPin.length < 4 || !managerNumber}
                  type="submit"
                  className="menu_payment_config_manager_modal-verify-btn"
                >
                  {storeMode === "OFFLINE" ? "Switch to Online Mode" : "Switch to Offline Mode"}
                </StyledButton>

                <div className="menu_payment_config_manager_modal-actions menu_payment_config_manager_modal-actions--center">
                  <button
                    onClick={handleClose}
                    className="menu_payment_config_manager_modal-cancel-btn"
                    type="button"
                  >
                    Cancel
                  </button>
                </div>
              </form>
            </div>
          </div>
        </div>
      )}
    </Navbar>
  );
};

export default PaymentTerminal;
